/**************************************************************************************************/
/*   File: /src/app/shared/enums/authorization.status.enum.ts                                     */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/

/**
 * The authorization status
 */
export enum AuthorizationStatus {
    /**
     * Authorization not exists
     */
    NOT_EXISTENT = 0, 
    /**
     * Authorization is requested
     */
    REQUESTED = 1, 
    /**
     * Authoirzation is approved
     */
    APPROVED = 2, 
    /**
     * Authorization is revoked
     */
    REVOKED = 3, 
    /**
     * Authorization is rejected
     */
    REJECTED = 4
}